module.exports = __webpack_public_path__ + "img/fss-demo-main-600x450.6e49f0cc.jpg";